import {
  Box,
  createStyles,
  Modal,
  TextInput,
  Select,
  Button,
  Text,
  Group,
  Radio,
  Grid,
  Flex,
  Menu,
  Loader,
  Center,
} from "@mantine/core";
import { TiDelete } from "react-icons/ti";
import React, { useEffect, useState } from "react";
import { encrypt } from "../../utils";
import { DatePickerInput } from "@mantine/dates";

import {
  editBilling,
  getAllBillingModal,
  GetBillingERADetais,
} from "../../services";
import swal from "sweetalert";
import { IconChevronDown } from "@tabler/icons-react";
import { FiSearch } from "react-icons/fi";
import moment from "moment";
import { FaCircleMinus, FaCirclePlus } from "react-icons/fa6";
import BillingSearchBar from "../Document/BillingSearchBar";
import { getdiagnosiscode } from "../../services/servicecode";
import { useSelector } from "react-redux";
import { BiExport } from "react-icons/bi";
import BillingHistory from "./BillingHistory";

const EditBilling = ({
  editbilling,
  SetEditbilling,
  billing,
  view,
  setDecryptedBillingData,
}) => {
  const [formData, setFormData] = useState("");
  const [showDiagnosisSearchBar, setShowDiagnosisSearchBar] = useState(false);
  const [diagnosisSearchValue, setDiagnosisSearchValue] = useState("");
  const alldiagnosiscode = useSelector(
    (state) => state.servicecode.alldiagnosisCode
  );
  const [hoveredDiagnosField, setHoveredDiagnosField] = useState(null);
  const [selectedKey, setSelectedKey] = useState("");
  const [loading, setLoading] = useState(false);
  const [oldunit, setOldUnit] = useState(null);
    const [billinghistory, SetBillinghistory] = useState(false);
  
  // console.log("billing", billing);

  // console.log('decryptedBillingData',decryptedBillingData);

    const openHistoryModal = () => {
    SetBillinghistory(true);
  };



  useEffect(() => {
    setFormData(billing?.claim);
  }, [billing]);

  const today = new Date();
  // const bgColor = "#D9D9D9";

  const bgColor = "#FFFFFF";

  const useStyles = createStyles(() => ({
    addbox: {
      // padding: '12px 12px 20px 30px',
      borderRadius: "12px",
      border: "1px solid #E5E5EA",
      background: "#FFF",
      padding: "0px 17px",
    },

    tabsinner: {
      // width: "15%",
      borderRadius: "8px",
      color: "#18181B",
      border: "1px solid  #FFAF4A;",
      background: "#FFAF4A;",
      padding: "8px 14px",
      boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
      textAlign: "center",
      cursor: "pointer",
      display: "flex",
      gap: "8px",
    },
    errormessage: {
      color: "red",
      fontSize: "12px",
      fontFamily: "Inter",
      marginTop: "5px",
    },

    othererros: {
      margin: "auto",
      width: "95%",
      marginBottom: "13px",
    },

    datepickerinput: {
      // width: "220px",
      // padding: "10px 14px",
      borderRadius: "8px",
      boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
      marginTop: "6px",
      backgroundColor: "#FFF",
      height: "48px",
      "& .mantine-DatePickerInput-wrapper, .mantine-DatePickerInput-input": {
        height: "100%",
        fontFamily: "Inter",
        borderRadius: "8px",
      },
    },

    formRow: {
      width: "100%",
      display: "flex",
      flexWrap: "wrap",
      marginBottom: "14px",
      fontFamily: "Inter",
      marginTop: "14px",
      justifyContent: "start",
      padding: "0px 15px",
      gap: "17px",
    },

    label: {
      whiteSpace: "nowrap",
    },

    textRow: {
      marginTop: "43px",
      justifyContent: "left",
    },

    inputParentBox: {
      width: "40%",

      "@media (max-width:955px)": {
        width: "100%",
      },
    },

    equalInputParentBox: {
      flex: 1,
      "@media (max-width:955px)": {
        width: "100%",
      },
      "& .providerNameSelect": {
        width: "217px",
        "@media (max-width:955px)": {
          width: "100%",
        },
      },
    },

    newinputParentBox: {
      width: "22.5%",

      "@media (max-width:955px)": {
        width: "100%",
      },
    },

    employeeinputParentBox: {
      width: "18.5%",

      "@media (max-width:955px)": {
        width: "100%",
      },
    },

    boxinside: {
      borderRadius: "8px",
      border: "1px solid #E5E5E5",
      background: "#F9FAFB",
      boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    },

    textInputBox: {
      width: "100%",
      padding: "0px 14px",
      height: "48px",
      borderRadius: "8px",
      border: "1px solid #E5E5E5",
      boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
      backgroundColor: bgColor,
      marginTop: "6px",
      "& .mantine-Input-wrapper": {
        height: "100%",
      },

      "& input": {
        backgroundColor: "#FFF !important",
        border: "none",
        fontFamily: "Inter",
        paddingInline: 0,
        padding: "0px 35px 0px 0px",
        height: "100%",
      },

      "& input:disabled": {
        backgroundColor: "#FFF !important",
        color: "#000",
        cursor: "not-allowed",
      },
    },

    diagnosisSearchBarContainer: {
      flex: 1,
      "& > div": {
        padding: "0px",
        flex: 1,
        background: "transparent",
        borderRadius: "0px",
      },
      "& .mantine-Autocomplete-root": {
        width: "100%",
        padding: "2px 14px",
        height: "48px",
        borderRadius: "8px",
        border: "1px solid #E5E5E5",
        boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
        backgroundColor: bgColor,
        "& .mantine-Input-wrapper": {
          height: "100%",
        },
        "& .mantine-Autocomplete-wrapper": {
          height: "100%",
        },

        "& input": {
          backgroundColor: "#FFF !important",
          border: "none",
          fontFamily: "Inter",
          padding: "0px 35px 0px 0px",
          paddingInline: 0,
          height: "100%",
        },
      },
    },

    insuredBox: {
      width: "30%",
    },

    groupbox: {
      marginTop: "6px",
      padding: "8px 14px 8px 14px",
      display: "flex",
      alignItems: "center",
      minHeight: "48px",
      background: "#FAFAFA",
      gap: "24px",
      border: "1px solid #E5E5E5",
      borderRadius: "8px",
      "& .mantine-Radio-root": {
        flex: 1,
      },
    },

    newgroupbox: {
      marginTop: "18px",
      padding: "8px 0px 8px 14px",
      display: "flex",
      gap: "13px",
      width: "50%",
      background: "#FAFAFA",
      border: "1px solid #E5E5E5",
      borderRadius: "8px",
      marginBottom: "14px",
    },

    employeegroupbox: {
      marginTop: "18px",
      padding: "8px 0px 8px 14px",
      display: "flex",
      gap: "13px",
      width: "100%",
      background: "#FAFAFA",
      border: "1px solid #E5E5E5",
      borderRadius: "8px",
      marginBottom: "14px",
    },

    addbtn: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: "5%",
      gap: "10px",
      marginBottom: "10px",
    },

    button: {
      "&:hover": {
        background: "#FFAF4A",
        color: "#FFFFFF",
        opacity: 0.8,
      },
    },

    history:{
      paddingBottom:'4px',
      paddingTop:'9px',
      display:'flex',
      justifyContent:'flex-end',
      cursor:"pointer"
    }
  }));

  const { classes } = useStyles();

  const handleClose = () => {
    SetEditbilling(false);
  };

  const handleDiagnosisSearchBarChange = (item) => {
    typeof item === "string" && item && getdiagnosiscode(item);
    if (item?.code && item?.shortdescription) {
      setFormData((prevState) => ({
        ...prevState,
        diagnosis: [
          ...prevState?.diagnosis,
          {
            code: item?.code,
            name: item?.shortdescription,
          },
        ],
      }));
      setDiagnosisSearchValue("");
    }
  };

  const CustomTextInput = ({ ...rest }) => {
    const useStyles = createStyles((theme) => ({
      textInputBox: {
        width: "100%",
        padding: "5px 15px",
        height: "48px",
        borderRadius: "8px",
        border: "1px solid #E5E5E5",
        backgroundColor: bgColor,
        "& input": {
          backgroundColor: "transparent",
          border: "none",
          paddingInline: 0,
          fontFamily: "Inter",
          height: "100%",
        },
      },
    }));
    const { classes } = useStyles();

    return (
      <div className={classes.textInputBox}>
        <TextInput {...rest} />
      </div>
    );
  };

  const CustomSelectBox = ({ ...rest }) => {
    const useStyles = createStyles((theme) => ({
      textInputBox: {
        width: "100%",
        marginTop: "6px",
        height: "auto",
        backgroundColor: bgColor,
        borderRadius: "8px",
        border: "1px solid #E5E5E5",
        "& > div > div, .mantine-Select-wrapper": {
          height: "auto",
        },
        "& input": {
          border: "none",
          paddingInline: 0,
          backgroundColor: "transparent",
          padding: "5px 11px",
          fontFamily: "Inter",
          height: "48px",
        },
        "& .mantine-Select-rightSection": {
          width: "fit-content",
          height: "inherit",
          marginRight: "5px",
        },
      },
    }));
    const { classes } = useStyles();

    return (
      <div className={classes.textInputBox}>
        <Select
          {...rest}
          rightSection={<IconChevronDown color={"#94A3B8"} size={20} />}
          rightSectionWidth={25}
          styles={{ rightSection: { pointerEvents: "none" } }}
        />
      </div>
    );
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const handleChange = (field, value) => {
    if (
      field &&
      value &&
      (field === "pat_dob" ||
        field === "ins_dob" ||
        field === "nowork_to_date" ||
        field === "nowork_from_date" ||
        field === "from_date" ||
        field === "thru_date" ||
        field === "cond_date" ||
        field === "cond_date" ||
        field === "onset_date" ||
        field === "lastseen_date" ||
        field === "hosp_from_date" ||
        field === "hosp_thru_date" ||
        field === "chiro_manifest_date" ||
        field === "info_release")
    ) {
      value = formatDate(value);
    }

    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const { allservicecode } = useSelector((state) => state?.servicecode);

  // const handleChargeChange = (index, field, date) => {
  //   // console.log('index, field, date', index, field, date);

  //   const formattedDate = formatDate(date);

  //   const updatedCharges = formData.charge.map((charge, idx) => {
  //     if (idx === index) {
  //       return {
  //         ...charge,
  //         [field]: formattedDate,
  //       };
  //     }
  //     return charge;
  //   });

  //   setFormData({ ...formData, charge: updatedCharges });
  // };

  const handleChargeChange = (index, field, value, oldUnitsParam = null) => {
    if (!oldunit) {
      setOldUnit(oldUnitsParam);
    }

    let updatedValue = value;

    const dateFields = ["from_date", "thru_date"];
    if (dateFields.includes(field) && value instanceof Date) {
      updatedValue = formatDate(value);
    }

    const updatedCharges = formData?.charge?.map((charge, idx) => {
      if (idx === index) {
        if (field === "units" && updatedValue && oldUnitsParam != null) {
          const oldUnits = parseFloat(oldunit ?? charge.units) || 1;
          const oldCharge = parseFloat(charge.charge) || 0;
          const newUnits = parseFloat(updatedValue) || 0;

          const unitCharge = oldCharge / oldUnits;
          const newCharge = parseFloat((unitCharge * newUnits).toFixed(2));

          return {
            ...charge,
            [field]: updatedValue,
            charge: newCharge,
          };
        }

        return {
          ...charge,
          [field]: updatedValue,
        };
      }
      return charge;
    });

    setFormData({ ...formData, charge: updatedCharges });
  };

  const handleSave = async () => {
    console.log("Updated Billing Data:", formData);

    let payload = {
      file: encrypt(formData),
      id: billing.id,
      claimid: formData.claimmd_id,
      filename: formData?.prov_name_m,
      claimmongoid: formData?._id,
    };

    console.log("payload", payload);

    let res = await editBilling(payload);
    console.log("res", res);

    if (res.status === 200) {
      swal({
        title: `Billing Details update successfully`,
        text: "Billing Details  update successfully",
        dangerMode: false,
      });
      // handleClose();
    }

    // SetEditbilling(false); // Close the modal after saving
    await getAllBillingModal({ page: 1 });
    setDecryptedBillingData(null);
    handleClose();
  };

  const getErrorMessage = (field) => {
    const error = formData?.errors?.find(
      (errorItem) => errorItem.fields === field
    );
    return error ? error.message : "";
  };

  // console.log("selectedKey", selectedKey);

  const getExlucdeErrorMessage = (excludeFields) => {
    const excludeFieldsArray = Array.isArray(excludeFields)
      ? excludeFields
      : [excludeFields];

    const filteredErrors = formData?.errors?.filter(
      (errorItem) => !excludeFieldsArray.includes(errorItem.fields)
    );

    if (filteredErrors && filteredErrors.length > 0) {
      return filteredErrors.map((error) => error.message).join(", ");
    }

    return "";
  };

  // console.log('loading',loading);

  // const geteraDetails = async (type) => {
  //   try {

  //    await setLoading(true);

  //     let payload = {
  //       type,
  //       claimmid: formData.claimmd_id,
  //     };

  //     const res = await GetBillingERADetais(payload);
  //     const eraDetails = res?.data?.billingEradetails;

  //     console.log("eraDetails", eraDetails);

  //     if (!eraDetails) {
  //       console.warn("No data available in response");
  //       return;
  //     }

  //     let content = null;
  //     let blob;
  //     let fileName;

  //     if (type === "pdf") {
  //       content = eraDetails.data?.[0];
  //       const byteCharacters = atob(content);
  //       const byteNumbers = Array.from(byteCharacters, (c) => c.charCodeAt(0));
  //       const byteArray = new Uint8Array(byteNumbers);
  //       blob = new Blob([byteArray], { type: "application/pdf" });
  //       fileName = `ERA_${payload.claimmid}.pdf`;
  //     } else if (type === "era") {
  //       content = eraDetails.data?.[0];
  //       blob = new Blob([content], { type: "text/plain" });
  //       fileName = `ERA_${payload.claimmid}.txt`;
  //     } else {
  //       content = eraDetails;
  //       const stringified = JSON.stringify(content, null, 2);
  //       const mimeType = type === "json" ? "application/json" : "text/xml";
  //       blob = new Blob([stringified], { type: mimeType });
  //       fileName = `ERA_${payload.claimmid}.${type}`;
  //     }

  //     const link = document.createElement("a");
  //     link.href = URL.createObjectURL(blob);
  //     link.download = fileName;
  //     document.body.appendChild(link);
  //     link.click();

  //     document.body.removeChild(link);
  //     URL.revokeObjectURL(link.href);

  //   } catch (error) {
  //     console.log("Error downloading ERA:", error);
  //   } finally {
  //       setLoading(false);
  //   }
  // };

  const geteraDetails = async (type) => {
    try {
      setLoading(true);

      // Yield back to the browser so loading state can render
      await new Promise((resolve) => setTimeout(resolve, 0));

      let payload = {
        type,
        claimmid: formData.claimmd_id,
      };

      const res = await GetBillingERADetais(payload);
      const eraDetails = res?.data?.billingEradetails;

      console.log("eraDetails", eraDetails);

      if (!eraDetails) {
        console.warn("No data available in response");
        return;
      }

      let content = null;
      let blob;
      let fileName;

      if (type === "pdf") {
        content = eraDetails.data?.[0];
        const byteCharacters = atob(content);
        const byteNumbers = Array.from(byteCharacters, (c) => c.charCodeAt(0));
        const byteArray = new Uint8Array(byteNumbers);
        blob = new Blob([byteArray], { type: "application/pdf" });
        fileName = `ERA_${payload.claimmid}.pdf`;
      } else if (type === "era") {
        content = eraDetails.data?.[0];
        blob = new Blob([content], { type: "text/plain" });
        fileName = `ERA_${payload.claimmid}.txt`;
      } else {
        content = eraDetails;
        const stringified = JSON.stringify(content, null, 2);
        const mimeType = type === "json" ? "application/json" : "text/xml";
        blob = new Blob([stringified], { type: mimeType });
        fileName = `ERA_${payload.claimmid}.${type}`;
      }

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.log("Error downloading ERA:", error);
    } finally {
      setLoading(false);
    }
  };

  // console.log("formData?.charge", formData?.charge);

  console.log('$$$%%%', formData)

  return (


    <>
    <Modal
      opened={editbilling}
      size={1400}
      shadow="md"
      // title="View Details (CMS 1500)"
      title={
        <Flex justify="space-between" align="center" w="100%">
          <Box>
            <span
              style={{
                fontSize: "24px",
                fontFamily: "Inter",
                fontWeight: 700,
                color: "#000",
              }}
            >
              View Details {formData?.claim_form === '837p' ? '(CMS 1500)' : formData?.claim_form === '837i' ? '(CMS 1450)' : null}
            </span>
          </Box>

          {billing?.claim?.status !== "A" || billing?.claim?.status !== "R" ? (
            <Box
              // style={{ backgroundColor: settingtrue }}
              className={classes.tabsinner}
            >
              {loading ? (
                <>
                  <Loader />
                </>
              ) : (
                <Menu shadow="md" width={177}>
                  <Menu.Target>
                    <Box>
                      <Text ff="Inter" fz={16} fw={600} color="#262626">
                        Download ERA
                      </Text>
                    </Box>
                  </Menu.Target>

                  <BiExport size={20} color="#000" variant="default" />

                  <Menu.Dropdown pos={"bottom-start"} top={"261px"}>
                    <Menu.Item
                      ff="Inter"
                      fz={14}
                      fw={600}
                      color="#262626"
                      onClick={() => geteraDetails("era")}

                      // onClick={() => handleEditProvider({ id: 1 }, true)}
                    >
                      ERA Format
                    </Menu.Item>
                    <Menu.Item
                      ff="Inter"
                      fz={14}
                      fw={600}
                      color="#262626"
                      onClick={() => geteraDetails("pdf")}
                      // onClick={() => handleEditProvider({ id: 1 }, false)}
                    >
                      PDF
                    </Menu.Item>
                    <Menu.Item
                      ff="Inter"
                      fz={14}
                      fw={600}
                      color="#262626"
                      onClick={() => geteraDetails("xml/json")}
                    >
                      XML/JSON
                    </Menu.Item>
                  </Menu.Dropdown>
                </Menu>
              )}
            </Box>
          ) : null}
        </Flex>
      }
      onClose={handleClose}
      overlayProps={{ blur: 3 }}
      radius="lg"
      zIndex={1000}
      centered
      
      styles={{
        title: {
          color: "#000",
          fontSize: "24px",
          fontFamily: "Inter",
          fontWeight: "700",
          width: "95%",
        },
            body: {
      backgroundColor: "#F4F4F5", 
    },
   
      }}

      
    >

      <Box onClick={openHistoryModal} className={classes.history}>
        <Text underline color="#737373" fs={14} fw={500} > View Claim History</Text>
       </Box>
      <Box  className={classes.addbox}>
        {/* Billing Info */}
        <div className={classes.textRow}>
          <Text ff={"Inter"} ta={"left"} fz={16} fw={700} color="#000">
            Load Payer
          </Text>
        </div>

        {/* Payer Info */}
        <div className={classes.formRow}>
          <div className={classes.inputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Payer Name{" "}
              <Text ff={"Inter"} component="span" color="red">
                *
              </Text>
            </Text>

            <TextInput
              // label="Payer Name"
              value={formData?.payer_name}
              onChange={(e) => handleChange("payer_name", e.target.value)}
              required
              className={classes.textInputBox}
              disabled={view}
            />

            <div className={classes.errormessage}>
              {getErrorMessage("payer_name")}
            </div>
          </div>

          <div className={classes.inputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Payer ID{" "}
              <Text ff={"Inter"} component="span" color="red">
                *
              </Text>
            </Text>
            <TextInput
              // label="Payer ID"
              value={formData?.payerid}
              className={classes.textInputBox}
              onChange={(e) => handleChange("payerid", e.target.value)}
              required
              disabled={view}
            />

            <div className={classes.errormessage}>
              {getErrorMessage("payerid")}
            </div>
          </div>
        </div>

        <div className={classes.formRow}>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Address{" "}
              <Text ff={"Inter"} component="span" color="red">
                *
              </Text>
            </Text>
            <TextInput
              className={classes.textInputBox}
              value={formData?.payer_addr_1}
              onChange={(e) => handleChange("payer_addr_1", e.target.value)}
              required
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("payer_addr_1")}
            </div>
          </div>

          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Address Line 2{" "}
              <Text ff={"Inter"} component="span" color="red">
                *
              </Text>
            </Text>
            <TextInput
              className={classes.textInputBox}
              value={formData?.payer_addr_2}
              onChange={(e) => handleChange("payer_addr_2", e.target.value)}
              required
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("payer_addr_2")}
            </div>
          </div>
        </div>

        <div className={classes.formRow}>
          <div style={{ width: "28%" }} className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              City{" "}
              <Text ff={"Inter"} component="span" color="red">
                *
              </Text>
            </Text>
            <TextInput
              className={classes.textInputBox}
              value={formData?.payer_city}
              onChange={(e) => handleChange("payer_city", e.target.value)}
              required
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("payer_city")}
            </div>
          </div>

          <div style={{ width: "32%" }} className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              State{" "}
              <Text ff={"Inter"} component="span" color="red">
                *
              </Text>
            </Text>
            <TextInput
              // label="Payer State"
              className={classes.textInputBox}
              value={formData?.payer_state}
              onChange={(e) => handleChange("payer_state", e.target.value)}
              required
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("payer_state")}
            </div>
          </div>

          <div style={{ width: "32%" }} className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Zip{" "}
              <Text ff={"Inter"} component="span" color="red">
                *
              </Text>
            </Text>
            <TextInput
              // label="Payer Zip"
              className={classes.textInputBox}
              value={formData?.payer_zip}
              onChange={(e) => handleChange("payer_zip", e.target.value)}
              required
              disabled={view}
            />

            <div className={classes.errormessage}>
              {getErrorMessage("payer_zip")}
            </div>
          </div>
        </div>

        <Text ff={"Inter"} ta="left" fz={16} fw={700} color="#000">
          1. Payer Entity
        </Text>

        <div className={classes.formRow}>
          <Radio.Group
            value={formData?.other_claimfilingcode}
            onChange={(value) => handleChange("other_claimfilingcode", value)}
            className={classes.groupbox}
          >
            <Radio
              fz={14}
              fw={500}
              color="#000"
              label="Medicare"
              value="Medicare"
            />
            <Radio
              fz={14}
              fw={500}
              color="#000"
              label="Medicaid"
              value="Medicaid"
            />
            <Radio
              fz={14}
              fw={500}
              color="#000"
              label="Tricare"
              value="Tricare"
            />

            <Radio
              fz={14}
              fw={500}
              color="#000"
              label="CHAMPVA"
              value="CHAMPVA"
            />
            <Radio
              fz={14}
              fw={500}
              color="#000"
              label="GROUP HEALTH"
              value="GROUP HEALTH"
            />
            <Radio
              fz={14}
              fw={500}
              color="#000"
              label="FECA BLK Lung"
              value="FECA BLK Lung"
            />
          </Radio.Group>
          <div className={classes.errormessage}>
            {getErrorMessage("other_claimfilingcode")}
          </div>
        </div>

        <div
          style={{ marginTop: "10px", marginBottom: "10px" }}
          className={classes.insuredBox}
        >
          <Text
            ff={"Inter"}
            ta="left"
            fz={14}
            fw={500}
            color="#344054"
            className={classes.label}
          >
            1A. Insureds ID Number{" "}
            <Text ff={"Inter"} component="span" color="red">
              *
            </Text>
          </Text>
          <TextInput
            // label="Payer Zip"
            className={classes.textInputBox}
            value={formData?.other_ins_medicare_code}
            onChange={(e) =>
              handleChange("other_ins_medicare_code", e.target.value)
            }
            required
            disabled={view}
          />

          <div className={classes.errormessage}>
            {getErrorMessage("other_ins_medicare_code")}
          </div>
        </div>

        <Text ff={"Inter"} fz={16} fw={700} color="#000">
          2. Client Name
        </Text>

        <div className={classes.formRow}>
          <div style={{ width: "28%" }} className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Last Name{" "}
              <Text ff={"Inter"} component="span" color="red">
                *
              </Text>
            </Text>
            <TextInput
              className={classes.textInputBox}
              value={formData?.pat_name_l}
              onChange={(e) => handleChange("pat_name_l", e.target.value)}
              required
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("pat_name_l")}
            </div>
          </div>

          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              First Name{" "}
              <Text ff={"Inter"} component="span" color="red">
                *
              </Text>
            </Text>
            <TextInput
              // label="Payer State"
              className={classes.textInputBox}
              value={formData?.pat_name_f}
              onChange={(e) => handleChange("pat_name_f", e.target.value)}
              required
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("pat_name_f")}
            </div>
          </div>

          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Middle Initial{" "}
              <Text ff={"Inter"} component="span" color="red">
                *
              </Text>
            </Text>
            <TextInput
              // label="Payer Zip"
              className={classes.textInputBox}
              value={formData?.pat_name_m}
              onChange={(e) => handleChange("pat_name_m", e.target.value)}
              required
              disabled={view}
            />

            <div className={classes.errormessage}>
              {getErrorMessage("pat_name_m")}
            </div>
          </div>
        </div>

        <Text ff={"Inter"} fz={16} fw={700} color="#000">
          3. Patient Info
        </Text>

        <div className={classes.formRow}>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Patient DOB{" "}
              <Text ff={"Inter"} component="span" color="red">
                *
              </Text>
            </Text>
            <DatePickerInput
              id="dob"
              // label="Patient DOB"
              // defaultDate={Date.now()}
              //  value={formData?.ins_dob}
              value={formData?.pat_dob ? new Date(formData?.pat_dob) : ""}
              className={classes.datepickerinput}
              disabled={view}
              // size="xl"
              placeholder="yyyy/mm/dd"
              icon={
                <img
                  style={{ width: "20px" }}
                  src={"/assets/images/billingcalendar.png"}
                  alt="Icon"
                />
              }
              styles={{ rightSection: { pointerEvents: "none" } }}
              // onChange={(e) => handleChange("pat_dob", e.target.value)}
              onChange={(date) => handleChange("pat_dob", date)}
              required
            />

            <div className={classes.errormessage}>
              {getErrorMessage("pat_dob")}
            </div>
          </div>

          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Sex{" "}
              <Text ff={"Inter"} component="span" color="red">
                *
              </Text>
            </Text>

            <Radio.Group
              value={formData?.pat_sex}
              onChange={(value) => handleChange("pat_sex", value)}
              className={classes.groupbox}
            >
              <Radio fz={14} fw={500} color="#000" label="Male" value="M" />
              <Radio fz={14} fw={500} color="#000" label="Female" value="F" />
              <Radio fz={14} fw={500} color="#000" label="Other" value="U" />
            </Radio.Group>
            <div className={classes.errormessage}>
              {getErrorMessage("pat_sex")}
            </div>
          </div>
        </div>

        <Text ff={"Inter"} fz={16} fw={700} color="#000">
          4. Insureds Name
        </Text>

        <div className={classes.formRow}>
          <div style={{ width: "28%" }} className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Last Name{" "}
              <Text ff={"Inter"} component="span" color="red">
                *
              </Text>
            </Text>
            <TextInput
              className={classes.textInputBox}
              value={formData?.ins_name_l}
              onChange={(e) => handleChange("ins_name_l", e.target.value)}
              required
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("ins_name_l")}
            </div>
          </div>

          <div style={{ width: "32%" }} className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              First Name{" "}
              <Text ff={"Inter"} component="span" color="red">
                *
              </Text>
            </Text>
            <TextInput
              // label="Payer State"
              className={classes.textInputBox}
              value={formData?.ins_name_f}
              onChange={(e) => handleChange("ins_name_f", e.target.value)}
              required
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("ins_name_f")}
            </div>
          </div>

          <div style={{ width: "32%" }} className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Middle Initial{" "}
              <Text ff={"Inter"} component="span" color="red">
                *
              </Text>
            </Text>
            <TextInput
              // label="Payer Zip"
              className={classes.textInputBox}
              value={formData?.ins_name_m}
              onChange={(e) => handleChange("ins_name_m", e.target.value)}
              required
              disabled={view}
            />

            <div className={classes.errormessage}>
              {getErrorMessage("ins_name_m")}
            </div>
          </div>
        </div>

        <Text ff={"Inter"} fz={16} fw={700} color="#000">
          5. Client Address
        </Text>

        <div className={classes.formRow}>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Address{" "}
              <Text ff={"Inter"} component="span" color="red">
                *
              </Text>
            </Text>
            <TextInput
              className={classes.textInputBox}
              value={formData?.pat_addr_1}
              onChange={(e) => handleChange("pat_addr_1", e.target.value)}
              required
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("pat_addr_1")}
            </div>
          </div>

          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Address Line 2{" "}
              <Text ff={"Inter"} component="span" color="red">
                *
              </Text>
            </Text>
            <TextInput
              className={classes.textInputBox}
              value={formData?.pat_addr_2}
              onChange={(e) => handleChange("pat_addr_2", e.target.value)}
              required
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("pat_addr_2")}
            </div>
          </div>
        </div>

        <div className={classes.formRow}>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              City{" "}
              <Text ff={"Inter"} component="span" color="red">
                *
              </Text>
            </Text>
            <TextInput
              className={classes.textInputBox}
              value={formData?.pat_city}
              onChange={(e) => handleChange("pat_city", e.target.value)}
              required
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("pat_city")}
            </div>
          </div>

          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              State{" "}
              <Text ff={"Inter"} component="span" color="red">
                *
              </Text>
            </Text>
            <TextInput
              // label="Payer State"
              className={classes.textInputBox}
              value={formData?.pat_state}
              onChange={(e) => handleChange("pat_state", e.target.value)}
              required
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("pat_state")}
            </div>
          </div>

          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Zip{" "}
              <Text ff={"Inter"} component="span" color="red">
                *
              </Text>
            </Text>
            <TextInput
              // label="Payer Zip"
              className={classes.textInputBox}
              value={formData?.pat_zip}
              onChange={(e) => handleChange("pat_zip", e.target.value)}
              required
              disabled={view}
            />

            <div className={classes.errormessage}>
              {getErrorMessage("pat_zip")}
            </div>
          </div>

          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Phone{" "}
              <Text ff={"Inter"} component="span" color="red">
                *
              </Text>
            </Text>
            <TextInput
              // label="Payer Zip"
              className={classes.textInputBox}
              value={formData?.pat_phone}
              onChange={(e) => handleChange("pat_phone", e.target.value)}
              required
              disabled={view}
            />

            <div className={classes.errormessage}>
              {getErrorMessage("pat_phone")}
            </div>
          </div>
        </div>

        <Text ff={"Inter"} fz={16} fw={700} color="#000">
          6. Clients Relationship to Insured
        </Text>
        <div className={classes.formRow}>
          <Group style={{ width: "100%" }}>
            <Radio.Group
              value={formData?.pat_rel}
              onChange={(value) => handleChange("pat_rel", value)}
              style={{ width: "50%" }}
              className={classes.groupbox}
            >
              <Radio fz={14} fw={500} color="#000" label="Self" value="18" />
              <Radio fz={14} fw={500} color="#000" label="spouse" value="1" />
              <Radio fz={14} fw={500} color="#000" label="Child" value="19" />
              <Radio fz={14} fw={500} color="#000" label="Other" value="G8" />
            </Radio.Group>
            <div className={classes.errormessage}>
              {getErrorMessage("pat_rel")}
            </div>
          </Group>
        </div>

        <Text ff={"Inter"} fz={16} fw={700} color="#000">
          7. Insureds Address
        </Text>

        <div className={classes.formRow}>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Address{" "}
              <Text ff={"Inter"} component="span" color="red">
                *
              </Text>
            </Text>
            <TextInput
              className={classes.textInputBox}
              value={formData?.ins_addr_1}
              onChange={(e) => handleChange("ins_addr_1", e.target.value)}
              required
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("ins_addr_1")}
            </div>
          </div>

          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Address Line 2{" "}
              <Text ff={"Inter"} component="span" color="red">
                *
              </Text>
            </Text>
            <TextInput
              className={classes.textInputBox}
              value={formData?.ins_addr_2}
              onChange={(e) => handleChange("ins_addr_2", e.target.value)}
              required
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("ins_addr_2")}
            </div>
          </div>
        </div>

        <div className={classes.formRow}>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              City{" "}
              <Text ff={"Inter"} component="span" color="red">
                *
              </Text>
            </Text>
            <TextInput
              className={classes.textInputBox}
              value={formData?.ins_city}
              onChange={(e) => handleChange("ins_city", e.target.value)}
              required
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("ins_city")}
            </div>
          </div>

          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              State{" "}
              <Text ff={"Inter"} component="span" color="red">
                *
              </Text>
            </Text>
            <TextInput
              // label="Payer State"
              className={classes.textInputBox}
              value={formData?.ins_state}
              onChange={(e) => handleChange("ins_state", e.target.value)}
              required
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("ins_state")}
            </div>
          </div>

          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Zip{" "}
              <Text ff={"Inter"} component="span" color="red">
                *
              </Text>
            </Text>
            <TextInput
              // label="Payer Zip"
              className={classes.textInputBox}
              value={formData?.ins_zip}
              onChange={(e) => handleChange("ins_zip", e.target.value)}
              required
              disabled={view}
            />

            <div className={classes.errormessage}>
              {getErrorMessage("ins_zip")}
            </div>
          </div>

          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Phone{" "}
              <Text ff={"Inter"} component="span" color="red">
                *
              </Text>
            </Text>
            <TextInput
              // label="Payer Zip"
              className={classes.textInputBox}
              value={formData?.ins_phone}
              onChange={(e) => handleChange("ins_phone", e.target.value)}
              required
              disabled={view}
            />

            <div className={classes.errormessage}>
              {getErrorMessage("ins_phone")}
            </div>
          </div>
        </div>

        <Text fz={16} fw={700} color="#000">
          9. Other Insured
        </Text>
        <div className={classes.formRow}>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Last Name
            </Text>
            <TextInput
              className={classes.textInputBox}
              value={formData?.other_ins_name_l}
              onChange={(e) => handleChange("other_ins_name_l", e.target.value)}
              required
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("other_ins_name_l")}
            </div>
          </div>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              First Name
            </Text>
            <TextInput
              value={formData?.other_ins_name_f}
              className={classes.textInputBox}
              onChange={(e) => handleChange("other_ins_name_f", e.target.value)}
              required
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("other_ins_name_f")}
            </div>
          </div>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Middle initial
            </Text>
            <TextInput
              className={classes.textInputBox}
              value={formData?.other_ins_name_m}
              onChange={(e) => handleChange("other_ins_name_m", e.target.value)}
              required
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("other_ins_name_m")}
            </div>
          </div>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Policy or Group Number
            </Text>
            <TextInput
              value={formData?.other_ins_number}
              className={classes.textInputBox}
              onChange={(e) => handleChange("other_ins_number", e.target.value)}
              required
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("other_ins_number")}
            </div>
          </div>
        </div>

        <Text ff={"Inter"} fz={16} fw={700} color="#000">
          10. Is Patient Condition Related to:
        </Text>

        <div className={classes.formRow}>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Employment (Current or Previous)?
            </Text>
            <Radio.Group
              value={formData?.employment_related}
              onChange={(value) => handleChange("employment_related", value)}
              className={classes.groupbox}
            >
              <Radio fz={14} fw={500} color="#000" label="Yes" value="Y" />
              <Radio fz={14} fw={500} color="#000" label="No" value="N" />
            </Radio.Group>
            <div className={classes.errormessage}>
              {getErrorMessage("employment_related")}
            </div>
          </div>

          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Auto Accident
            </Text>
            <Radio.Group
              value={formData?.auto_accident}
              onChange={(value) => handleChange("auto_accident", value)}
              className={classes.groupbox}
            >
              <Radio fz={14} fw={500} color="#000" label="Yes" value="Y" />
              <Radio fz={14} fw={500} color="#000" label="No" value="N" />
            </Radio.Group>
            <div className={classes.errormessage}>
              {getErrorMessage("auto_accident")}
            </div>
          </div>

          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              If Yes, Add State
            </Text>
            <TextInput
              // label="Payer Zip"
              className={classes.textInputBox}
              value={formData?.auto_accident_state}
              onChange={(e) =>
                handleChange("auto_accident_state", e.target.value)
              }
              required
              disabled={view}
            />

            <div className={classes.errormessage}>
              {getErrorMessage("auto_accident_state")}
            </div>
          </div>

          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Other Accident{" "}
              <Text ff={"Inter"} component="span" color="red">
                *
              </Text>
            </Text>
            <Radio.Group
              value={formData?.other_accident}
              onChange={(value) => handleChange("other_accident", value)}
              className={classes.groupbox}
            >
              <Radio fz={14} fw={500} color="#000" label="Yes" value="Y" />
              <Radio fz={14} fw={500} color="#000" label="No" value="N" />
            </Radio.Group>
            <div className={classes.errormessage}>
              {getErrorMessage("other_accident")}
            </div>
          </div>

          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              10D. Claim Code
            </Text>
            <TextInput
              // label="Payer Zip"
              className={classes.textInputBox}
              value={formData?.claim_form}
              onChange={(e) => handleChange("claim_form", e.target.value)}
              required
              disabled={view}
            />

            <div className={classes.errormessage}>
              {getErrorMessage("claim_form")}
            </div>
          </div>
        </div>

        <Text ff={"Inter"} fz={16} fw={700} color="#000">
          11. Insured Policy Group or FECA Number
        </Text>

        <div className={classes.formRow}>
          <div style={{ width: "28%" }} className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Policy Group or FECA ID
            </Text>
            <TextInput
              className={classes.textInputBox}
              value={formData?.ins_group}
              onChange={(e) => handleChange("ins_group", e.target.value)}
              required
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("ins_group")}
            </div>
          </div>

          <div style={{ width: "32%" }} className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Sex
            </Text>
            <Radio.Group
              value={formData?.ins_sex}
              onChange={(value) => handleChange("ins_sex", value)}
              className={classes.groupbox}
            >
              <Radio fz={14} fw={500} color="#000" label="Male" value="M" />
              <Radio fz={14} fw={500} color="#000" label="Female" value="F" />
              <Radio fz={14} fw={500} color="#000" label="Other" value="U" />
            </Radio.Group>
            <div className={classes.errormessage}>
              {getErrorMessage("ins_sex")}
            </div>
          </div>

          <div style={{ width: "28%" }} className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Insurance DOB{" "}
              <Text ff={"Inter"} component="span" color="red">
                *
              </Text>
            </Text>
            <DatePickerInput
              id="dob"
              // label="Patient DOB"
              // defaultDate={Date.now()}
              //  value={formData?.ins_dob}
              // value={
              //   formData?.ins_dob ? new Date(formData?.ins_dob) : new Date()
              // }
              value={
                isNaN(new Date(formData?.ins_dob).getTime())
                  ? "No valid date"
                  : new Date(formData?.ins_dob)
              }
              className={classes.datepickerinput}
              defaultValue={new Date()}
              disabled={view}
              // size="xl"
              placeholder="yyyy/mm/dd"
              icon={
                <img
                  style={{ width: "20px" }}
                  src={"/assets/images/billingcalendar.png"}
                  alt="Icon"
                />
              }
              styles={{ rightSection: { pointerEvents: "none" } }}
              // onChange={(e) => handleChange("pat_dob", e.target.value)}
              onChange={(date) => handleChange("ins_dob", date)}
              required
            />
            <div className={classes.errormessage}>
              {getErrorMessage("ins_dob")}
            </div>
          </div>
        </div>

        <div
          className={classes.formRow}
          style={{ justifyContent: "space-between" }}
        >
          <div className={classes.equalInputParentBox} style={{ width: "30%" }}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Other Claim Entity Name or ID
            </Text>
            <TextInput
              className={classes.textInputBox}
              onChange={(e) => handleChange("", e.target.value)}
              required
              disabled={view}
            />
            <div className={classes.errormessage}>{getErrorMessage()}</div>
          </div>

          <div style={{ width: "30%" }} className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Insurance Plan Name or Program Name
            </Text>
            <TextInput
              className={classes.textInputBox}
              value={formData?.ins_plan}
              onChange={(e) => handleChange("ins_plan", e.target.value)}
              required
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("ins_plan")}
            </div>
          </div>

          <div style={{ width: "30%" }} className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Is there another Health Benefit Plan?
            </Text>
            <Radio.Group
              onChange={(value) => handleChange("", value)}
              className={classes.groupbox}
              style={{ width: "fit-content" }}
            >
              <Radio fz={14} fw={500} color="#000" label="Yes" value="Y" />
              <Radio fz={14} fw={500} color="#000" label="No" value="N" />
            </Radio.Group>
            <div className={classes.errormessage}>{getErrorMessage()}</div>
          </div>
        </div>
        <Grid gutter={19}>
          <Grid.Col span={6}>
            <Text ff={"Inter"} fz={16} fw={700} color="#000">
              12. Patients Or Authorized Person Signature
            </Text>
            <div
              className={classes.formRow}
              style={{ justifyContent: "space-between" }}
            >
              <div style={{ width: "100%" }} className={classes.inputParentBox}>
                <Text
                  ff={"Inter"}
                  ta="left"
                  fz={14}
                  fw={500}
                  color="#344054"
                  className={classes.label}
                >
                  Signed
                </Text>
                <Radio.Group
                  value={formData?.attach_acn}
                  onChange={(value) => handleChange("attach_acn", value)}
                  className={classes.groupbox}
                  style={{ width: "fit-content" }}
                >
                  <Radio fz={14} fw={500} color="#000" label="Yes" value="Y" />
                  <Radio fz={14} fw={500} color="#000" label="No" value="N" />
                </Radio.Group>
                <div className={classes.errormessage}>
                  {getErrorMessage("attach_acn")}
                </div>
              </div>
            </div>
          </Grid.Col>
          <Grid.Col span={6}>
            <Text ff={"Inter"} fz={16} fw={700} color="#000">
              13. Insured Or Authorized Person Signature
            </Text>
            <div
              className={classes.formRow}
              style={{ justifyContent: "space-between" }}
            >
              <div style={{ width: "100%" }} className={classes.inputParentBox}>
                <Text
                  ff={"Inter"}
                  ta="left"
                  fz={14}
                  fw={500}
                  color="#344054"
                  className={classes.label}
                >
                  Signed
                </Text>
                <Radio.Group
                  value={formData?.attach_type_code}
                  onChange={(value) => handleChange("attach_type_code", value)}
                  className={classes.groupbox}
                  style={{ width: "fit-content" }}
                >
                  <Radio fz={14} fw={500} color="#000" label="Yes" value="Y" />
                  <Radio fz={14} fw={500} color="#000" label="No" value="N" />
                </Radio.Group>
                <div className={classes.errormessage}>
                  {getErrorMessage("attach_type_code")}
                </div>
              </div>
            </div>
          </Grid.Col>
        </Grid>
        <Text ff={"Inter"} fz={16} fw={700} color="#000">
          14. Date of Condition
        </Text>

        <div className={classes.formRow}>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Date
            </Text>
            <DatePickerInput
              id="dob"
              className={classes.datepickerinput}
              defaultValue={new Date()}
              value={
                formData?.cond_date ? new Date(formData?.cond_date) : new Date()
              }
              disabled={view}
              placeholder="yyyy/mm/dd"
              icon={
                <img
                  style={{ width: "20px" }}
                  src={"/assets/images/billingcalendar.png"}
                  alt="Icon"
                />
              }
              styles={{ rightSection: { pointerEvents: "none" } }}
              onChange={(date) => handleChange("cond_date", date)}
              required
            />
            <div className={classes.errormessage}>
              {getErrorMessage("cond_date")}
            </div>
          </div>

          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Qualifier
            </Text>
            <TextInput
              className={classes.textInputBox}
              value={"Date of Condition"}
              required
              disabled={true}
            />
            <div className={classes.errormessage}>{getErrorMessage()}</div>
          </div>
        </div>
        <Text ff={"Inter"} fz={16} fw={700} color="#000">
          15. Other Date
        </Text>

        <div className={classes.formRow}>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Qualifier
            </Text>
            <CustomSelectBox
              data={[
                { value: "onset_date", label: "Date of Onset" },
                { value: "lastseen_date", label: "Date Last Seen" },

                { value: "hosp_from_date", label: "Hospital Admit Date" },
                { value: "hosp_thru_date", label: "Hospital Discharge Date" },
                {
                  value: "chiro_manifest_date",
                  label: "Chiro Condition Manifest Date",
                },
                { value: "info_release", label: "Info Release Date" },
              ]}
              value={selectedKey}
              onChange={(val) => setSelectedKey(val)}
              disabled={view}
            />

            <div className={classes.errormessage}>{getErrorMessage()}</div>
          </div>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Date
            </Text>
            <DatePickerInput
              id="dob"
              className={classes.datepickerinput}
              defaultValue={new Date()}
              disabled={view}
              placeholder="yyyy/mm/dd"
              icon={
                <img
                  style={{ width: "20px" }}
                  src={"/assets/images/billingcalendar.png"}
                  alt="Icon"
                />
              }
              styles={{ rightSection: { pointerEvents: "none" } }}
              /// onChange={(date) => handleChange("", date)}
              onChange={(date) => handleChange(selectedKey, date)}
              required
            />
            <div className={classes.errormessage}>{getErrorMessage()}</div>
          </div>
        </div>
        <Text ff={"Inter"} fz={16} fw={700} color="#000">
          16 Date Patients Unable to Work In Current Occupation
        </Text>

        <div className={classes.formRow}>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              From Date
            </Text>
            <DatePickerInput
              id="dob"
              className={classes.datepickerinput}
              defaultValue={new Date()}
              value={
                formData?.nowork_from_date
                  ? new Date(formData?.nowork_from_date)
                  : new Date()
              }
              disabled={view}
              placeholder="yyyy/mm/dd"
              icon={
                <img
                  style={{ width: "20px" }}
                  src={"/assets/images/billingcalendar.png"}
                  alt="Icon"
                />
              }
              styles={{ rightSection: { pointerEvents: "none" } }}
              onChange={(date) => handleChange("nowork_from_date", date)}
              required
            />
            <div className={classes.errormessage}>
              {getErrorMessage("nowork_from_date")}
            </div>
          </div>

          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              To Date
            </Text>
            <DatePickerInput
              id="dob"
              className={classes.datepickerinput}
              defaultValue={new Date()}
              value={
                formData?.nowork_to_date
                  ? new Date(formData?.nowork_to_date)
                  : new Date()
              }
              disabled={view}
              placeholder="yyyy/mm/dd"
              icon={
                <img
                  style={{ width: "20px" }}
                  src={"/assets/images/billingcalendar.png"}
                  alt="Icon"
                />
              }
              styles={{ rightSection: { pointerEvents: "none" } }}
              onChange={(date) => handleChange("nowork_to_date", date)}
              required
            />
            <div className={classes.errormessage}>
              {getErrorMessage("nowork_to_date")}
            </div>
          </div>
        </div>

        <Text ff={"Inter"} fz={16} fw={700} color="#000">
          17. Name Of Referring Provider
        </Text>

        <div className={classes.formRow}>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              First Name
            </Text>
            <TextInput
              className={classes.textInputBox}
               onChange={(e) => handleChange("ref_name_f", e.target.value)}
            required
               value={formData?.ref_name_f}
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("ref_name_f")}
            </div>
          </div>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Middle Name
            </Text>
            <TextInput
              className={classes.textInputBox}
              onChange={(e) => handleChange("ref_name_m", e.target.value)}
              required
              disabled={view}
              value={formData?.ref_name_m}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("ref_name_m")}
            </div>
          </div>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Last Name
            </Text>
            <TextInput
              className={classes.textInputBox}
              onChange={(e) => handleChange("ref_name_l", e.target.value)}
              required
              disabled={view}
              value={formData?.ref_name_l}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("ref_name_l")}
            </div>
          </div>
        </div>

        <Text ff={"Inter"} fz={16} fw={700} color="#000">
          17a. Name Of Referring Provider
        </Text>

        <div className={classes.formRow}>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Referring Npi
            </Text>
            <TextInput
              className={classes.textInputBox}
              onChange={(e) => handleChange("ref_npi", e.target.value)}
              required
              value={formData?.ref_npi}
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("ref_npi")}
            </div>
          </div>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Other ID
            </Text>
            <TextInput
              className={classes.textInputBox}
              onChange={(e) => handleChange("ref_id", e.target.value)}
              required
              disabled={view}
              value={formData?.ref_id}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("ref_id")}
            </div>
          </div>
        </div>
        <Text ff={"Inter"} fz={16} fw={700} color="#000">
          18. Hospitalization Dates Related To Current Services
        </Text>

        <div className={classes.formRow}>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Hosp From Date
            </Text>
            <DatePickerInput
              // id={`hosp_from_date${index}`}
              className={classes.datepickerinput}
              maxDate={today}
              // defaultValue={moment(from_date, "YYYY-MM-DD").toDate()}
              disabled={view}
              // value={moment(hosp_from_date, "YYYY-MM-DD").toDate()}
              value={
                formData?.hosp_from_date
                  ? new Date(formData?.hosp_from_date)
                  : new Date()
              }
              placeholder="yyyy/mm/dd"
              icon={
                <img
                  style={{ width: "20px" }}
                  src={"/assets/images/billingcalendar.png"}
                  alt="Icon"
                />
              }
              styles={{ rightSection: { pointerEvents: "none" } }}
              onChange={(date) => handleChange("hosp_from_date", date)}
              required
            />
            <div className={classes.errormessage}>
              {getErrorMessage("hosp_from_date")}
            </div>
          </div>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Hosp To Date
            </Text>
            <DatePickerInput
              className={classes.datepickerinput}
              maxDate={today}
              // defaultValue={moment(thru_date, "YYYY-MM-DD").toDate()}

              // value={moment(thru_date, "YYYY-MM-DD").toDate()}
              value={
                formData?.hosp_thru_date
                  ? new Date(formData?.hosp_thru_date)
                  : new Date()
              }
              disabled={view}
              placeholder="yyyy/mm/dd"
              icon={
                <img
                  style={{ width: "20px" }}
                  src={"/assets/images/billingcalendar.png"}
                  alt="Icon"
                />
              }
              styles={{ rightSection: { pointerEvents: "none" } }}
              // onChange={(date) =>
              //   handleChargeChange(index, "hosp_thru_date", date)
              // }
              onChange={(date) => handleChange("hosp_thru_date", date)}
              required
            />
            <div className={classes.errormessage}>
              {getErrorMessage("hosp_thru_date")}
            </div>
          </div>
        </div>

        <Text ff={"Inter"} fz={16} fw={700} color="#000">
          19. Additional Claim Information (Designed By NUCC)
        </Text>

        <div className={classes.formRow}>
          <div style={{ width: "30%" }} className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Additional Claim Information
            </Text>
            <TextInput
              className={classes.textInputBox}
              value={formData?.narrative}
              onChange={(e) => handleChange("narrative", e.target.value)}
              required
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("narrative")}
            </div>
          </div>
        </div>

        <Text ff={"Inter"} fz={16} fw={700} color="#000">
          20. Outside Lab?
        </Text>

        <div className={classes.formRow}>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Outside Lab
            </Text>
            <Radio.Group
              value={formData?.homebound}
              onChange={(value) => handleChange("homebound", value)}
              className={classes.groupbox}
            >
              <Radio fz={14} fw={500} color="#000" label="Yes" value="Y" />
              <Radio fz={14} fw={500} color="#000" label="No" value="N" />
            </Radio.Group>
            <div className={classes.errormessage}>
              {getErrorMessage("homebound")}
            </div>
          </div>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Charges
            </Text>
            <TextInput
              className={classes.textInputBox}
              onChange={(e) => handleChange("total_charge", e.target.value)}
              value={formData?.total_charge}
              disabled
              required
            />
            <div className={classes.errormessage}>
              {getErrorMessage("total_charge")}
            </div>
          </div>
        </div>

        <Text ff={"Inter"} fz={16} fw={700} color="#000">
          21. Diagnosis Or Nature of Illness Or Injury
        </Text>

        <div className={classes.formRow} style={{ alignItems: "center" }}>
          {formData?.diagnosis?.map(({ name, code }, index) => (
            <div className={classes.equalInputParentBox} key={code}>
              <div
                onMouseEnter={() => setHoveredDiagnosField(index)}
                onMouseLeave={() => setHoveredDiagnosField(null)}
              >
                <TextInput
                  className={classes.textInputBox}
                  value={name}
                  disabled={view}
                  rightSection={
                    hoveredDiagnosField === index ? (
                      <TiDelete
                        size={26}
                        cursor="pointer"
                        color="red"
                        onClick={() => {
                          const updatedDiagnosis = [...formData?.diagnosis];
                          updatedDiagnosis.splice(index, 1);
                          setFormData((prevState) => ({
                            ...prevState,
                            diagnosis: updatedDiagnosis,
                          }));
                        }}
                      />
                    ) : (
                      <FiSearch size={23} />
                    )
                  }
                />
              </div>
              <div className={classes.errormessage}>
                {getErrorMessage("diagnosis")}
              </div>
            </div>
          ))}
          {showDiagnosisSearchBar && (
            <BillingSearchBar
              placeholder="Search diagnos name..."
              className={classes.diagnosisSearchBarContainer}
              rightSection={<FiSearch size={23} />}
              icon={null}
              data={(alldiagnosiscode &&
              alldiagnosiscode.diagnosiscode &&
              diagnosisSearchValue
                ? alldiagnosiscode.diagnosiscode
                : []
              ).map((item) => ({
                value: item,
                label: item?.shortdescription,
                key: item?.code,
              }))}
              onChange={(item) => handleDiagnosisSearchBarChange(item)}
              value={
                typeof diagnosisSearchValue === "string"
                  ? diagnosisSearchValue
                  : diagnosisSearchValue?.shortdescription
              }
              setValue={setDiagnosisSearchValue}
            />
          )}
          {!view &&
            (showDiagnosisSearchBar ? (
              <FaCircleMinus
                cursor="pointer"
                color="#000"
                size={25}
                onClick={() => setShowDiagnosisSearchBar(false)}
              />
            ) : (
              <FaCirclePlus
                color="#000"
                cursor="pointer"
                size={25}
                onClick={() => setShowDiagnosisSearchBar(true)}
              />
            ))}
        </div>

        <Text ff={"Inter"} fz={16} fw={700} color="#000">
          22. Resubmission
        </Text>

        <div className={classes.formRow}>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Resubmission Code
            </Text>
            <TextInput
              className={classes.textInputBox}
              value={formData?.frequency_code}
              onChange={(e) => handleChange("frequency_code", e.target.value)}
              required
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("frequency_code")}
            </div>
          </div>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Original Ref No.
            </Text>
            <TextInput
              value={formData?.referral_number}
              className={classes.textInputBox}
              onChange={(e) => handleChange("referral_number", e.target.value)}
              required
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("referral_number")}
            </div>
          </div>
        </div>

        <Text ff={"Inter"} fz={16} fw={700} color="#000">
          23. Prior Authorization
        </Text>

        <div className={classes.formRow}>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Prior Authorization Number
            </Text>
            <TextInput
              className={classes.textInputBox}
              onChange={(e) => handleChange("prior_auth", e.target.value)}
              required
              value={formData?.prior_auth}
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("prior_auth")}
            </div>
          </div>
        </div>

        <Text ff={"Inter"} fz={16} fw={700} color="#000">
          24. Dates, Proccedures of Service
        </Text>

        {formData?.charge?.map(
          (
            {
              from_date,
              thru_date,
              charge,
              charge_record_type,
              diag_ref,
              proc_code,
              place_of_service,
              remote_chgid,
              units,
            },
            index
          ) => (
            <div key={index} className={classes.formRow}>
              <div className={classes.equalInputParentBox}>
                <Text
                  ff={"Inter"}
                  ta="left"
                  fz={14}
                  fw={500}
                  color="#344054"
                  className={classes.label}
                >
                  From Date
                </Text>
                <DatePickerInput
                  id={`from_date${index}`}
                  className={classes.datepickerinput}
                  maxDate={today}
                  // defaultValue={moment(from_date, "YYYY-MM-DD").toDate()}
                  disabled={view}
                  value={moment(from_date, "YYYY-MM-DD").toDate()}
                  placeholder="yyyy/mm/dd"
                  icon={
                    <img
                      style={{ width: "20px" }}
                      src={"/assets/images/billingcalendar.png"}
                      alt="Icon"
                    />
                  }
                  styles={{ rightSection: { pointerEvents: "none" } }}
                  onChange={(date) =>
                    handleChargeChange(index, "from_date", date)
                  }
                  required
                />
                <div className={classes.errormessage}>{getErrorMessage()}</div>
              </div>
              <div className={classes.equalInputParentBox}>
                <Text
                  ff={"Inter"}
                  ta="left"
                  fz={14}
                  fw={500}
                  color="#344054"
                  className={classes.label}
                >
                  To Date
                </Text>
                <DatePickerInput
                  id={`thru_date${index}`}
                  className={classes.datepickerinput}
                  maxDate={today}
                  // defaultValue={moment(thru_date, "YYYY-MM-DD").toDate()}

                  value={moment(thru_date, "YYYY-MM-DD").toDate()}
                  disabled={view}
                  placeholder="yyyy/mm/dd"
                  icon={
                    <img
                      style={{ width: "20px" }}
                      src={"/assets/images/billingcalendar.png"}
                      alt="Icon"
                    />
                  }
                  styles={{ rightSection: { pointerEvents: "none" } }}
                  onChange={(date) =>
                    handleChargeChange(index, "thru_date", date)
                  }
                  required
                />
                <div className={classes.errormessage}>{getErrorMessage()}</div>
              </div>

              <div className={classes.equalInputParentBox}>
                <Text
                  ff={"Inter"}
                  ta="left"
                  fz={14}
                  fw={500}
                  color="#344054"
                  className={classes.label}
                >
                  PROC Code
                  <Text ff={"Inter"} component="span" color="red"></Text>
                </Text>
                <TextInput
                  id={`proc_code${index}`}
                  // label="Payer State"
                  className={classes.textInputBox}
                  value={proc_code}
                  onChange={(date) =>
                    handleChargeChange(index, "proc_code", date)
                  }
                  required
                  disabled={true}
                />
                <div className={classes.errormessage}>
                  {getErrorMessage("proc_code")}
                </div>
              </div>

              <div className={classes.equalInputParentBox}>
                <Text
                  ff={"Inter"}
                  ta="left"
                  fz={14}
                  fw={500}
                  color="#344054"
                  className={classes.label}
                >
                  Charge Record Type
                  <Text ff={"Inter"} component="span" color="red"></Text>
                </Text>

                <CustomSelectBox
                  id={`charge_record_type${index}`}
                  data={[
                    { value: "UN", label: "Units" },
                    { value: "MJ", label: "Minutes" },
                  ]}
                  value={charge_record_type}
                  onChange={(selected) =>
                    handleChargeChange(index, "charge_record_type", selected)
                  }
                  disabled={view}
                />

                <div className={classes.errormessage}>
                  {getErrorMessage("charge_record_type")}
                </div>
              </div>

              <div className={classes.equalInputParentBox}>
                <Text
                  ff={"Inter"}
                  ta="left"
                  fz={14}
                  fw={500}
                  color="#344054"
                  className={classes.label}
                >
                  Diag Ref
                  <Text ff={"Inter"} component="span" color="red"></Text>
                </Text>
                <TextInput
                  id={`diag_ref${index}`}
                  // label="Payer State"
                  className={classes.textInputBox}
                  value={diag_ref}
                  onChange={(e) =>
                    handleChargeChange(index, "diag_ref", e.target.value)
                  }
                  required
                  disabled={view}
                />
                <div className={classes.errormessage}>
                  {getErrorMessage("diag_ref")}
                </div>
              </div>

              <div className={classes.equalInputParentBox}>
                <Text
                  ff={"Inter"}
                  ta="left"
                  fz={14}
                  fw={500}
                  color="#344054"
                  className={classes.label}
                >
                  Place Of Service
                  <Text ff={"Inter"} component="span" color="red"></Text>
                </Text>
                {/* <TextInput
                  id={`place_of_service${index}`}
                  // label="Payer State"
                  className={classes.textInputBox}
                  value={place_of_service}
                  onChange={(date) =>
                    handleChargeChange(index, "place_of_service", date)
                  }
                  required
                  disabled={view}
                /> */}
                <CustomSelectBox
                  id={`place_of_service${index}`}
                  value={place_of_service}
                  data={(allservicecode && allservicecode.servicescode
                    ? allservicecode.servicescode
                    : []
                  )

                    .map((item) => ({
                      value: item?.code,
                      label: item?.code,
                    }))

                    .sort((a, b) => a.label.localeCompare(b.label))}
                  onChange={(selected) =>
                    handleChargeChange(index, "place_of_service", selected)
                  }
                  disabled={view}
                />

                <div className={classes.errormessage}>
                  {getErrorMessage("place_of_service")}
                </div>
              </div>

              <div className={classes.equalInputParentBox}>
                <Text
                  ff={"Inter"}
                  ta="left"
                  fz={14}
                  fw={500}
                  color="#344054"
                  className={classes.label}
                >
                  Remote Chgid
                  <Text ff={"Inter"} component="span" color="red"></Text>
                </Text>
                <TextInput
                  id={`remote_chgid${index}`}
                  // label="Payer State"
                  className={classes.textInputBox}
                  value={remote_chgid}
                  onChange={(e) =>
                    handleChargeChange(index, "remote_chgid", e.target.value)
                  }
                  required
                  disabled={view}
                />
                <div className={classes.errormessage}>
                  {getErrorMessage("remote_chgid")}
                </div>
              </div>

              <div className={classes.equalInputParentBox}>
                <Text
                  ff={"Inter"}
                  ta="left"
                  fz={14}
                  fw={500}
                  color="#344054"
                  className={classes.label}
                >
                  Units
                  <Text ff={"Inter"} component="span" color="red"></Text>
                </Text>
                <TextInput
                  id={`units${index}`}
                  // label="Payer State"
                  className={classes.textInputBox}
                  value={units}
                  onChange={(e) =>
                    // handleChargeChange(index, "units", e.target.value)
                    handleChargeChange(index, "units", e.target.value, units)
                  }
                  required
                  disabled={true}
                />
                <div className={classes.errormessage}>
                  {getErrorMessage("units")}
                </div>
              </div>

              <div className={classes.equalInputParentBox}>
                <Text
                  ff={"Inter"}
                  ta="left"
                  fz={14}
                  fw={500}
                  color="#344054"
                  className={classes.label}
                >
                  Charge
                  <Text ff={"Inter"} component="span" color="red"></Text>
                </Text>
                <TextInput
                  id={`charge${index}`}
                  // label="Payer State"
                  className={classes.textInputBox}
                  value={charge}
                  // onChange={(date) => handleChargeChange(index, "charge", date)}
                  required
                  disabled={true}
                />
                <div className={classes.errormessage}>
                  {getErrorMessage("charge")}
                </div>
              </div>
            </div>
          )
        )}

        <div style={{ padding: "0px" }} className={classes.formRow}>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              fz={16}
              fw={700}
              color="#000"
              // className={classes.label}
            >
              25 A. Federal Tax ID Number
              <Text ff={"Inter"} component="span" color="red"></Text>
            </Text>
            <Radio.Group
              value={formData?.prov_taxid_type}
              onChange={(value) => handleChange("prov_taxid_type", value)}
              className={classes.groupbox}
            >
              <Radio fz={14} fw={500} color="#000" label="SSN" value="Y" />
              <Radio fz={14} fw={500} color="#000" label="EIN" value="N" />
            </Radio.Group>
            <div className={classes.errormessage}>
              {getErrorMessage("prov_taxid_type")}
            </div>
          </div>

          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              fz={16}
              fw={700}
              color="#000"
              // className={classes.label}
            >
              25 B. #/ID
              <Text ff={"Inter"} component="span" color="red"></Text>
            </Text>
            <TextInput
              // label="Payer State"
              className={classes.textInputBox}
              value={formData?.prov_taxid}
              onChange={(e) => handleChange("prov_taxid", e.target.value)}
              required
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("prov_taxid")}
            </div>
          </div>

          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              fz={16}
              fw={700}
              color="#000"
              // className={classes.label}
            >
              26. Patients Account Number
            </Text>
            <TextInput
              // label="Payer State"
              className={classes.textInputBox}
              value={formData?.ins_number}
              onChange={(e) => handleChange("ins_number", e.target.value)}
              required
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("ins_number")}
            </div>
          </div>

          <div className={classes.equalInputParentBox}>
            <Text ff={"Inter"} fz={16} fw={700} color="#000">
              27. Accept Assignment
            </Text>
            <Radio.Group
              value={formData?.accept_assign}
              onChange={(value) => handleChange("accept_assign", value)}
              className={classes.groupbox}
            >
              <Radio fz={14} fw={500} color="#000" label="Yes" value="Y" />
              <Radio fz={14} fw={500} color="#000" label="No" value="N" />
            </Radio.Group>

            <div className={classes.errormessage}>
              {getErrorMessage("accept_assign")}
            </div>
          </div>
        </div>

        <div style={{ padding: "0px" }} className={classes.formRow}>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              fz={16}
              fw={700}
              color="#000"
              // className={classes.label}
            >
              28. Amount Charge
              <Text ff={"Inter"} component="span" color="red"></Text>
            </Text>
            <TextInput
              // label="Payer State"
              className={classes.textInputBox}
              value={formData?.total_charge}
              // onChange={(e) => handleChange("total_charge", e.target.value)}

              disabled={true}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("total_charge")}
            </div>
          </div>

          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              fz={16}
              fw={700}
              color="#000"
              // className={classes.label}
            >
              29. Amount Paid
            </Text>
            <TextInput
              // label="Payer State"
              className={classes.textInputBox}
              value={formData?.total_charge}
              onChange={(e) => handleChange("total_charge", e.target.value)}
              required
              disabled={true}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("total_charge")}
            </div>
          </div>

          <div className={classes.equalInputParentBox}>
            <Text ff={"Inter"} fz={16} fw={700} color="#000">
              30. Balance
            </Text>
            <TextInput
              // label="Payer State"
              className={classes.textInputBox}
              value={formData?.total_charge}
              onChange={(e) => handleChange("total_charge", e.target.value)}
              required
              disabled={true}
            />

            <div className={classes.errormessage}>
              {getErrorMessage("total_charge")}
            </div>
          </div>
        </div>

        <Text ff={"Inter"} fz={16} fw={700} color="#000">
          31. Service Facility Location Information
        </Text>

        <div className={classes.formRow}>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Facility Name
            </Text>
            <TextInput
              className={classes.textInputBox}
              onChange={(e) => handleChange("facility_name", e.target.value)}
              // required
              value={formData?.facility_name}
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("facility_name")}
            </div>
          </div>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              NPI
            </Text>
            <TextInput
              className={classes.textInputBox}
              onChange={(e) => handleChange("facility_npi", e.target.value)}
              // required
              disabled={view}
              value={formData?.facility_npi}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("facility_npi")}
            </div>
          </div>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Facility ID
            </Text>
            <TextInput
              className={classes.textInputBox}
              onChange={(e) => handleChange("facility_id", e.target.value)}
              // required
              disabled={view}
              value={formData?.facility_id}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("facility_id")}
            </div>
          </div>
        </div>

        <div className={classes.formRow}>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Address
            </Text>
            <TextInput
              className={classes.textInputBox}
              onChange={(e) => handleChange("facility_addr_1", e.target.value)}
              // required
              value={formData?.facility_addr_1}
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("facility_addr_1")}
            </div>
          </div>
        </div>

        <div className={classes.formRow}>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              City
            </Text>
            <TextInput
              className={classes.textInputBox}
              onChange={(e) => handleChange("facility_city", e.target.value)}
              // required
              value={formData?.facility_city}
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("facility_city")}
            </div>
          </div>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              State
            </Text>
            <TextInput
              className={classes.textInputBox}
              onChange={(e) => handleChange("facility_state", e.target.value)}
              // required
              disabled={view}
              value={formData?.facility_state}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("facility_state")}
            </div>
          </div>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Zip
            </Text>
            <TextInput
              className={classes.textInputBox}
              onChange={(e) => handleChange("facility_zip", e.target.value)}
              // required
              disabled={view}
              value={formData?.facility_zip}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("facility_zip")}
            </div>
          </div>
        </div>

        <Text ff={"Inter"} fz={16} fw={700} color="#000">
          32. Billing Provider Info & Phone
        </Text>

        <div className={classes.formRow}>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Billing Organization Name
            </Text>
            <TextInput
              className={classes.textInputBox}
              onChange={(e) => handleChange("bill_name", e.target.value)}
              // required
              disabled={view}
              value={formData?.bill_name}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("bill_name")}
            </div>
          </div>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Billing Specialty/Taxonomy
            </Text>
            <TextInput
              className={classes.textInputBox}
              onChange={(e) => handleChange("bill_taxonomy", e.target.value)}
              // required
              disabled={view}
              value={formData?.bill_taxonomy}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("bill_taxonomy")}
            </div>
          </div>

          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              NPI
            </Text>
            <TextInput
              className={classes.textInputBox}
              onChange={(e) => handleChange("bill_npi", e.target.value)}
              // required
              value={formData?.bill_npi}
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("bill_npi")}
            </div>
          </div>
        </div>

        <div className={classes.formRow}>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              BILL ID
            </Text>
            <TextInput
              style={{ width: "20%" }}
              className={classes.textInputBox}
              onChange={(e) => handleChange("bill_id", e.target.value)}
              // required
              value={formData?.bill_id}
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("bill_id")}
            </div>
          </div>
        </div>

        <div className={classes.formRow}>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Address
            </Text>
            <TextInput
              className={classes.textInputBox}
              onChange={(e) => handleChange("bill_addr_1", e.target.value)}
              // required
              value={formData?.bill_addr_1}
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("bill_addr_1")}
            </div>
          </div>
        </div>

        <div className={classes.formRow}>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Address 2
            </Text>
            <TextInput
              className={classes.textInputBox}
              onChange={(e) => handleChange("bill_addr_2", e.target.value)}
              // required
              value={formData?.bill_addr_2}
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("bill_addr_2")}
            </div>
          </div>
        </div>

        <div className={classes.formRow}>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              City
            </Text>
            <TextInput
              className={classes.textInputBox}
              onChange={(e) => handleChange("bill_city", e.target.value)}
              // required
              value={formData?.bill_city}
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("bill_city")}
            </div>
          </div>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              State
            </Text>
            <TextInput
              className={classes.textInputBox}
              onChange={(e) => handleChange("bill_state", e.target.value)}
              // required
              disabled={view}
              value={formData?.bill_state}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("bill_state")}
            </div>
          </div>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Zip
            </Text>
            <TextInput
              className={classes.textInputBox}
              onChange={(e) => handleChange("bill_zip", e.target.value)}
              // required
              disabled={view}
              value={formData?.bill_zip}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("bill_zip")}
            </div>
          </div>

          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Phone
            </Text>
            <TextInput
              className={classes.textInputBox}
              onChange={(e) => handleChange("bill_phone", e.target.value)}
              // required
              value={formData?.bill_phone}
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("bill_phone")}
            </div>
          </div>
        </div>

        {/* <Text ff={"Inter"} fz={16} fw={700} color="#000">
          33. Rendering Provider
        </Text>

        <div className={classes.formRow}>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Last Name
            </Text>
            <TextInput
              className={classes.textInputBox}
              onChange={(e) => handleChange("chg_prov_name_l", e.target.value)}
              // required
              value={formData?.chg_prov_name_l}
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("chg_prov_name_l")}
            </div>
          </div>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              First Name
            </Text>
            <TextInput
              className={classes.textInputBox}
              onChange={(e) => handleChange("chg_prov_name_f", e.target.value)}
              // required
              disabled={view}
              value={formData?.chg_prov_name_f}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("chg_prov_name_f")}
            </div>
          </div>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Middle Name
            </Text>
            <TextInput
              className={classes.textInputBox}
              onChange={(e) => handleChange("chg_prov_name_m", e.target.value)}
              // required
              disabled={view}
              value={formData?.chg_prov_name_m}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("chg_prov_name_m")}
            </div>
          </div>
        </div>

        <div className={classes.formRow}>
          <div className={classes.equalInputParentBox}>
            <Text
              ff={"Inter"}
              ta="left"
              fz={14}
              fw={500}
              color="#344054"
              className={classes.label}
            >
              Rendering Specialty/Taxonomy
            </Text>
            <TextInput
              className={classes.textInputBox}
              onChange={(e) =>
                handleChange("chg_prov_taxonomy", e.target.value)
              }
              // required
              value={formData?.chg_prov_taxonomy}
              disabled={view}
            />
            <div className={classes.errormessage}>
              {getErrorMessage("chg_prov_taxonomy")}
            </div>
          </div>
        </div> */}

        {!view && (
          <div className={classes.addbtn}>
            <Button
              className={classes.button}
              c={"#171717"}
              bg={"#F9FAFB"}
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              className={classes.button}
              c={"#171717"}
              bg={"#FFAF4A"}
              onClick={handleSave}
            >
              Save Changes
            </Button>
          </div>
        )}

        <div className={classes.othererros}>
          <Text ff={"Inter"} fz={18} fw={700} color="#000">
            Other Errors / warnings
          </Text>

          <div className={classes.errormessage}>
            {getExlucdeErrorMessage([
              "bill_taxid_type",
              "bill_taxid",
              "payer_name",
              "payerid",
              "payer_addr_1",
              "payer_addr_2",
              "payer_city",
              "payer_state",
              "pcn",
              "payer_zip",
              "payer_order",
              "prov_name_f",
              "prov_name_m",
              "prov_taxonomy",
              "prov_npi",
              "ref_name_f",
              "ref_name_m",
              "ref_name_l",
              "ref_npi",
              "remote_batchid",
              "remote_claimid",
              "remote_fileid",
              "ins_addr_1",
              "ins_addr_2",
              "ins_city",
              "ins_dob",
              "ins_state",
              "ins_zip",
              "ins_group",
              "ins_name_f",
              "ins_name_l",
              "ins_name_m",
              "ins_number",
              "ins_phone",
              "ins_sex",
              "pat_name_f",
              "pat_name_l",
              "pat_name_m",
              "pat_sex",
              "pat_addr_1",
              "pat_city",
              "pat_dob",
              "pat_state",
              "pat_zip",
              "pat_phone",
              "pat_rel",
              "accept_assign",
              "bill_npi",
              "prov_id",
              "claim_form",
            ])}
          </div>
        </div>
      </Box>
    </Modal>



<BillingHistory
    billinghistory={billinghistory}
          SetBillinghistory={SetBillinghistory}
          billing={billing}


/>
</>
  );
};

export default EditBilling;
